import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IdleTimer } from './shared/helpers/idle-timer';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { ErrorLoggingService } from './core/service/error-logging.service';
import { AppSettings } from './core/configs/app.settings';


@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    CoreModule,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    IonicModule.forRoot(),
    BrowserAnimationsModule,
    GoogleTagManagerModule.forRoot({
      id: AppSettings.gtmId
    })
  ],
  providers: [
    FileOpener,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    IdleTimer,
    {
      // used for global unhandled exception capture and logging to server
      provide: ErrorHandler,
      useClass: ErrorLoggingService
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
